import AntdStepsWithPanel from 'components/AntdStepsWithPanel/index'
import { CollapseComp } from 'components/CollapseStyle/index'
import DriveStatus from 'modules/Drives/ViewDriveRole/IndividualDriveTable/DriveStatus/index'
import CollapseText from 'modules/Drives/ViewDriveRole/IndividualDriveTable/ViewCandidateInfoDrawer/InterviewDetails/CollapseText/index'
import UpdateStatus from 'modules/Drives/ViewDriveRole/IndividualDriveTable/ViewCandidateInfoDrawer/InterviewDetails/UpdateStatus/index'
import {
  Container,
  LeftDiv,
  RoundDiv,
  StepRoundFlex,
  StepsFlex,
  StickyDiv,
  Titlediv,
} from 'modules/Drives/ViewDriveRole/IndividualDriveTable/ViewCandidateInfoDrawer/InterviewDetails/style'
import React, { useEffect, useState } from 'react'
import { getZeroBeforeInt } from 'utils/getZeroBeforeInt'

const { Panel } = CollapseComp

const RoundsSteps = ({
  setScheduleDrawer,
  setCandidateInfo,
  rolesMetrics,
  candidateInterviewDetails,
  candidateInfoData,
  updateInterviewStatus,
  driveId,
  roleId,
  getCandidateList,
  selectedRoundType,
  getRoleMetrics,
  setSelectedCandidate,
  setSelectedCandidateId,
  getSingleCandidateInterviewDetails,
}) => {
  const [current, setCurrent] = useState(null)
  const [updateStatus, setUpdateStatus] = useState(false)
  const [completedStep, setCompletedStep] = useState()

  useEffect(() => {
    let names = rolesMetrics[0]?.rounds?.map(({ roundName }, index) => {
      return roundName
    })
    setCompletedStep(names?.indexOf(candidateInfoData?.stage))
  }, [candidateInfoData, rolesMetrics])

  const onChange = value => {
    setCurrent(value)
  }

  const getCurrentRoundInfo = roundName => {
    let roundInfo =
      candidateInterviewDetails?.candidateInterviewDetails?.filter(data => {
        if (data?.interview?.interviewRound === roundName) {
          return data
        }
      })[0]
    return roundInfo
  }

  const genExtra = () => {
    return (
      <StepRoundFlex>
        {candidateInfoData?.status === 'SCHEDULED' ||
        candidateInfoData?.status === 'HOLD' ? (
          <></>
        ) : (
          ''
        )}
        {(candidateInfoData?.status === 'SELECTED' ||
          candidateInfoData?.status === 'REJECTED') && (
          <div>
            <DriveStatus
              status={candidateInfoData?.status}
              offerStatus={candidateInfoData?.offerStatus}
            />
          </div>
        )}
      </StepRoundFlex>
    )
  }

  const stepsData = rolesMetrics[0]?.rounds
    ?.slice(0, rolesMetrics[0]?.rounds?.length - 1)
    ?.map((round, index) => {
      return {
        key: index,
        activeKey: index,
        title: (
          <CollapseComp
            key={index + round?.roundName}
            defaultActiveKey={
              candidateInfoData?.stage === round?.roundName && [index + 1]
            }
            onChange={onChange}
            expandIconPosition={'end'}
            accordion
            bordered={
              candidateInfoData?.stage === round?.roundName &&
              candidateInfoData?.status !== 'SHORTLISTED'
            }
            value={current}
          >
            <Panel
              header={
                <StepsFlex spaceBetween>
                  <StepRoundFlex column>
                    <RoundDiv>Round {getZeroBeforeInt(index + 1)}</RoundDiv>
                    <Titlediv>{round?.roundName}</Titlediv>
                  </StepRoundFlex>
                  {candidateInfoData?.stage === round?.roundName && genExtra()}
                </StepsFlex>
              }
              key={index + 1}
              collapsible={
                getCurrentRoundInfo(round?.roundName) === false &&
                candidateInterviewDetails?.candidateInterviewDetails?.length !==
                  0 &&
                'disabled'
              }
            >
              {!!getCurrentRoundInfo(round?.roundName) !== false && (
                <p>
                  <CollapseText
                    interviewRoundInfo={getCurrentRoundInfo(round?.roundName)}
                    interviwerDeatils={
                      candidateInterviewDetails?.interviewerDetails?.data
                        ?.interviewere
                    }
                    candidateInfoData={candidateInfoData}
                  />
                </p>
              )}
            </Panel>
          </CollapseComp>
        ),
      }
    })

  return (
    <>
      <Container>
        <LeftDiv>
          <StickyDiv>
            <AntdStepsWithPanel current={completedStep} steps={stepsData} />
          </StickyDiv>
        </LeftDiv>
      </Container>
      {updateStatus && (
        <UpdateStatus
          updateStatus={updateStatus}
          setUpadateStatus={setUpdateStatus}
          setCandidateInfo={setCandidateInfo}
          candidateInfoData={candidateInfoData}
          candidateInterviewDetails={candidateInterviewDetails}
          interviwerDeatils={
            candidateInterviewDetails?.interviewerDetails?.data?.interviewere
          }
          rolesMetrics={rolesMetrics}
          updateInterviewStatus={updateInterviewStatus}
          driveId={driveId}
          roleId={roleId}
          getCandidateList={getCandidateList}
          getRoleMetrics={getRoleMetrics}
          setSelectedCandidate={setSelectedCandidate}
          setSelectedCandidateId={setSelectedCandidateId}
          getSingleCandidateInterviewDetails={
            getSingleCandidateInterviewDetails
          }
        />
      )}
    </>
  )
}

export default RoundsSteps
